<div #categoryChart class="categoryChart" id="categoryChart"></div>
